import React from "react";
import "./GetMusicOnBeatport.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOnBeatport = () => {

  const steps = [
    "Create your FT Tunes account",
    "Upload music & artwork",
    "Select Beatport distribution",
    "Release approved by stores",
    "Go live worldwide",
    "Track sales & royalties"
  ];

  return (
    <>
      <Helmet>
        <title>
          Get Your Music on Beatport | Beatport Distribution | FT Tunes
        </title>

        <meta
          name="description"
          content="Distribute your music to Beatport with FT Tunes. Release electronic, techno, house, and DJ music worldwide and reach global club audiences."
        />

        <meta
          name="keywords"
          content="Beatport distribution, upload music to Beatport, electronic music distribution, DJ music distribution, FT Tunes"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="beatport-page">

        {/* HERO */}
        <section className="beatport-hero">
          <Container>

            <img
              src="/Images/beatport-logo.png"
              alt="Beatport Distribution"
              className="beatport-logo"
            />

            <h1>Get Your Music on Beatport</h1>

            <p>
              Release your electronic music on Beatport and reach DJs,
              producers, and dance music fans worldwide. Beatport is the
              leading platform for house, techno, EDM, trance, and club
              music distribution. With FT Tunes, your tracks go live
              globally while you keep full ownership and earn royalties
              from downloads and DJ charts.
            </p>

            <Button
              className="gradient-btn"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Releasing Music
            </Button>

          </Container>

          <div className="hero-glow-beatport"></div>
        </section>


        {/* SHOWCASE */}
        <section className="beatport-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Reach Global DJs & Clubs</h2>

                <p>
                  Beatport connects your music directly to DJs,
                  festivals, clubs, and electronic music listeners.
                  Promote your releases, chart tracks, and build
                  credibility within the global dance music industry.
                </p>

                <Button
                  className="outline-btn"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Upload Music
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-music-on-beatport.png"
                  alt="Beatport Music Distribution"
                  className="beatport-image"
                />
              </Col>

            </Row>
          </Container>
        </section>


        {/* STEPS */}
        <section className="beatport-steps">
          <Container>

            <h2 className="section-title">How It Works</h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>


        {/* BENEFITS */}
        <section className="beatport-benefits">
          <Container>

            <h2 className="section-title">
              Built For Electronic Artists
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>DJ Audience</h5>
                  <p>Reach professional DJs and club music fans.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Genre Focus</h5>
                  <p>Perfect for EDM, techno, house & trance.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Download Revenue</h5>
                  <p>Earn from high-value music downloads.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Full Ownership</h5>
                  <p>You keep 100% rights to your music.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>


        {/* CTA */}
        <section className="beatport-cta">
          <Container>

            <h2>Release Your Tracks on Beatport Today</h2>

            <Button
              className="gradient-btn big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Distribute Now
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOnBeatport;